import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2",
  id: "tab-billing"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "flex w-full"
};
const _hoisted_4 = {
  class: "w-5/12"
};
const _hoisted_5 = {
  class: "alert alert-info"
};
const _hoisted_6 = {
  class: "alert alert-info"
};
const _hoisted_7 = {
  class: "py-2"
};
const _hoisted_8 = {
  class: "w-7/12"
};
const _hoisted_9 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_10 = {
  class: "alert alert-warning"
};
const _hoisted_11 = {
  style: {
    "margin-left": "20px"
  }
};
import LlCheckbox from '@/components/LlCheckbox.vue';
import Loader from '@/components/Loader.vue';
import MainHeader from '@/components/MainHeader.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import InvoicePreviewTable from './InvoicePreviewTable.vue';
import { reactive, onMounted, computed } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
export default {
  __name: 'CompanyInvoice',
  props: {
    accountingService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const meStore = useMeStore();
    const companyStore = useCompanyStore();
    let invoiceState = reactive({
      loading: false,
      me: {},
      service: '',
      expense: '',
      saving: false,
      unsaved: false,
      lines: [],
      form: {
        format: {}
      },
      company: {},
      connected: false,
      quickbooksLink: '',
      features: {}
    });
    const props = __props;
    onMounted(async () => {
      invoiceState.loading = true;
      await verifyConnected();
      const me = await meStore.getMe();
      invoiceState.me = me;
      // This is added because Me store is not recognizing the features from env.json
      const getMe = await props.userService.getMe();
      invoiceState.features = getMe.features;
      invoiceState.quickbooksLink = `${me.configuration.quickbooks}/app/formstyles`;
      companyUpdated(me.company);
      invoiceState.company = me.company;
      invoiceState.loading = false;
    });
    function companyUpdated(company) {
      invoiceState.form.format = JSON.parse(JSON.stringify(company.settings.invoice || {}));
      const {
        settings
      } = company || {};
      invoiceState.service = settings.accountingService?.name || 'Services';
      invoiceState.expense = settings.expenses?.accountingService?.name || 'Billable Expenses';
      invoiceState.form.matterBillingAddress = company.settings.matterBillingAddress;
      invoiceState.form.includeDateInDescription = company.settings.includeDateInDescription;
      invoiceState.initialIncludeDateInDescription = company.settings.includeDateInDescription;
      invoiceState.form.showSubheaders = company.settings.showSubheaders;
      invoiceState.form.invoiceDateCreated = company.settings.invoiceDateCreated;
      update();
    }
    async function cancel() {
      companyUpdated(invoiceState.company);
    }
    async function verifyConnected() {
      try {
        await props.accountingService.verify(false);
        invoiceState.connected = true;
      } catch (err) {
        invoiceState.connected = false;
      }
    }
    function goToCustomFieldsPage(path) {
      props.state.go('settings.company.customFields');
    }

    // Unset means "last day": the toggle needs a value in its option set, or it
    // picks one itself and marks the form changed.
    const invoiceDateOptions = [{
      label: 'Last Day of Billing Period',
      value: false
    }, {
      label: 'When Invoice was Created',
      value: true
    }];
    const example = [{
      date: new Date(2018, 11, 20),
      hours: 1,
      hourString: '1.0',
      description: 'Research',
      amount: 200,
      rate: 200,
      account: 'PP'
    }, {
      date: new Date(2018, 11, 20),
      hours: 0.2,
      hourString: '.2',
      description: 'Meeting with expert witness',
      amount: 40,
      rate: 200,
      account: 'PP'
    }, {
      date: new Date(2018, 11, 22),
      hours: 1.5,
      hourString: '1.5',
      description: 'Court apperance',
      amount: 300,
      rate: 200,
      account: 'ML',
      codes: 'A100'
    }, {
      date: new Date(2018, 11, 25),
      hours: 1,
      hourString: '1.0',
      description: 'Introductory meeting',
      amount: 0,
      rate: 0,
      account: 'ML',
      codes: 'A310'
    }];
    function update() {
      const {
        format
      } = invoiceState.form;
      let items = JSON.parse(JSON.stringify(example || {}));
      if (format.combineHours) {
        items.forEach(item => {
          item.description = `${item.description} (${item.hourString})`;
        });
      }
      if (format.combine) {
        const a = items[0];
        const b = items[1];
        const c = {
          description: `${a.description}; ${b.description};`,
          hours: a.hours + b.hours,
          amount: a.amount + b.amount,
          account: a.account,
          rate: a.rate,
          date: a.date
        };
        items = [c, items[2], items[3]];
      }
      items.forEach(item => {
        if (format.includeUser) {
          item.description = `${item.account}: ${item.description}`;
        }
        if (format.includeMatter) {
          item.description = `Matter Name: ${item.description}`;
        }
        if (format.includeCodes && item.codes) {
          item.description = `${item.codes}: ${item.description}`;
        }
        if (invoiceState.form.includeDateInDescription) {
          item.description = `${stringMonthDay(item)} - ${item.description}`;
        }
      });
      function stringMonthDay(item) {
        return `${new Date(item.date).getMonth()}/${new Date(item.date).getDate()}`;
      }
      let groups = [];
      if (format.combineBillable) {
        groups = [{
          name: invoiceState.service,
          items
        }];
      } else {
        groups = [{
          name: invoiceState.service,
          items: items.filter(i => i.amount)
        }, {
          name: `Non-Billable ${invoiceState.service}`,
          items: items.filter(i => !i.amount)
        }];
      }
      const lines = [];
      groups.forEach(group => {
        if (invoiceState.form.showSubheaders) {
          lines.push({
            date: group.items[0].date,
            description: `====== ${group.name}`
          });
        }
        if (format.invoiceSortReverse) {
          group.items.sort((a, b) => b.date - a.date);
        }
        group.items.forEach(item => {
          lines.push(item);
        });
        lines.push({
          subtotal: true,
          amount: items.reduce((sum, item) => sum + item.amount, 0)
        });
      });
      invoiceState.lines = lines;
    }
    function saveSettings() {
      invoiceState.saving = true;
      companyStore.updateMyCompany({
        settings: {
          showSubheaders: invoiceState.form.showSubheaders,
          matterBillingAddress: invoiceState.form.matterBillingAddress,
          includeDateInDescription: invoiceState.form.includeDateInDescription,
          invoice: invoiceState.form.format,
          invoiceDateCreated: invoiceState.form.invoiceDateCreated
        }
      }).then(company => {
        companyUpdated(company);
        props.alerts.success('Your settings were saved.');
      }).catch(err => {
        props.alerts.error(err);
      }).finally(() => {
        invoiceState.saving = false;
      });
    }
    const somethingChanged = computed(() => {
      if (invoiceState.form.showSubheaders !== invoiceState.company?.settings?.showSubheaders) {
        return true;
      }
      if (invoiceState.form.matterBillingAddress !== invoiceState.company?.settings?.matterBillingAddress) {
        return true;
      }
      if (invoiceState.form.includeDateInDescription !== invoiceState.company?.settings?.includeDateInDescription) {
        return true;
      }
      if (invoiceState.form.invoiceDateCreated !== invoiceState.company?.settings?.invoiceDateCreated) {
        return true;
      }
      if (JSON.stringify(invoiceState.form.format) !== JSON.stringify(invoiceState.company?.settings?.invoice)) {
        return true;
      }
      return false;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(invoiceState).loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Invoice Presentation',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MainHeader, {
        content: 'Invoice Presentation'
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[36] || (_cache[36] = _createElementVNode("i", null, "Change a setting and see the effect in the preview on the right.", -1)), _cache[37] || (_cache[37] = _createElementVNode("h4", null, "Description and Items", -1)), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.includeUser,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(invoiceState).form.format.includeUser = $event),
        label: "Include User Name in Description for Services",
        onCheckboxClick: _cache[1] || (_cache[1] = $event => update())
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.includeUserInExpenseDescription,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(invoiceState).form.format.includeUserInExpenseDescription = $event),
        label: "Include User Name in Description for Expenses"
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.includeCodes,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(invoiceState).form.format.includeCodes = $event),
        label: "Include LEDES Codes in Description",
        onCheckboxClick: _cache[4] || (_cache[4] = $event => update())
      }, null, 8, ["modelValue"]), [[_vShow, _unref(invoiceState).me.company?.settings?.codes?.ledes]]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.includeMatter,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(invoiceState).form.format.includeMatter = $event),
        label: `Include ${_unref(invoiceState).me.terms?.matter} Names in Time, Expense and Fixed Fee Descriptions`,
        onCheckboxClick: _cache[6] || (_cache[6] = $event => update())
      }, null, 8, ["modelValue", "label"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.combine,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(invoiceState).form.format.combine = $event),
        label: "Combine Time Entries for Same Day",
        onCheckboxClick: _cache[8] || (_cache[8] = $event => update())
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.combineHours,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(invoiceState).form.format.combineHours = $event),
        label: "Include Hours in Description",
        onCheckboxClick: _cache[10] || (_cache[10] = $event => update())
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.combineBillable,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(invoiceState).form.format.combineBillable = $event),
        label: "Combine Billable and Non-Billable",
        onCheckboxClick: _cache[12] || (_cache[12] = $event => update())
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.invoiceSortReverse,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(invoiceState).form.format.invoiceSortReverse = $event),
        label: "Sort Line Items in Reverse",
        onCheckboxClick: _cache[14] || (_cache[14] = $event => update())
      }, null, 8, ["modelValue"]), _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)), _cache[39] || (_cache[39] = _createElementVNode("h4", null, "Summaries", -1)), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.summaryAccountMemo,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(invoiceState).form.format.summaryAccountMemo = $event),
        label: "Timekeeper Detail in Memo",
        info: "A summary of timekeepers will be added to the invoice memo field.",
        onCheckboxClick: _cache[16] || (_cache[16] = $event => _unref(invoiceState).form.format.summaryAccount = false)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.summaryAccount,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(invoiceState).form.format.summaryAccount = $event),
        label: "Timekeeper Detail in Attachment",
        info: "The details of the invoice will be an Excel attachment to the invoice. The invoice itself will be a summary organized by timekeepers.",
        onCheckboxClick: _cache[18] || (_cache[18] = $event => _unref(invoiceState).form.format.summaryAccountMemo = false)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.format.disablePaymentLinkMemo,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(invoiceState).form.format.disablePaymentLinkMemo = $event),
        label: "No Payment Link in Memo",
        info: "Remove payment link from invoice memo (Confido Legal)"
      }, null, 8, ["modelValue"]), _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)), _cache[41] || (_cache[41] = _createElementVNode("h4", null, "Structure", -1)), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.showSubheaders,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(invoiceState).form.showSubheaders = $event),
        label: "Add Sub-Headers to Invoice Sections",
        onCheckboxClick: _cache[21] || (_cache[21] = $event => update())
      }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_5, " If you enable this setting, you should go to QuickBooks and modify the custom form style to *not* include the product/service designation on invoices. ", 512), [[_vShow, _unref(invoiceState).form.showSubheaders && !_unref(invoiceState).form.initialShowSubheaders]]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.includeDateInDescription,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(invoiceState).form.includeDateInDescription = $event),
        label: "Make Date Part of Invoice Description",
        onCheckboxClick: _cache[23] || (_cache[23] = $event => update())
      }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_6, " If you enable this setting, you should go to QuickBooks and modify the custom form style to *not* include the date column on invoices. ", 512), [[_vShow, _unref(invoiceState).form.includeDateInDescription && !_unref(invoiceState).initialIncludeDateInDescription]]), _createVNode(LlCheckbox, {
        modelValue: _unref(invoiceState).form.matterBillingAddress,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _unref(invoiceState).form.matterBillingAddress = $event),
        label: `${_unref(invoiceState).me.terms?.matter} in Billing Address`,
        onCheckboxClick: _cache[25] || (_cache[25] = $event => update())
      }, null, 8, ["modelValue", "label"]), _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)), _withDirectives(_createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("h4", null, "Custom Invoice Fields", -1)), _createVNode(LlSecondaryButton, {
        onClick: _cache[26] || (_cache[26] = $event => goToCustomFieldsPage('settings.company.customFields'))
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode(" Map Custom Fields ", -1)]))]),
        _: 1
      })], 512), [[_vShow, _unref(invoiceState).connected]]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)), _cache[34] || (_cache[34] = _createElementVNode("h4", null, "Invoice Dates", -1)), _cache[35] || (_cache[35] = _createElementVNode("p", null, " We recommend using the last day of the billing period for the invoice date. This is because reports that are concerned with \"Billed Revenue\" will report invoice amounts based on invoice date. Using the last day of billing period will account for the billed revenue in the month where the work is done. ", -1)), _createElementVNode("div", _hoisted_7, [_createVNode(LlButtonToggle, {
        "model-value": Boolean(_unref(invoiceState).form.invoiceDateCreated),
        items: invoiceDateOptions,
        "aria-label": "Invoice date",
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(invoiceState).form.invoiceDateCreated = $event)
      }, null, 8, ["model-value"])])])]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[44] || (_cache[44] = _createElementVNode("p", null, [_createElementVNode("b", null, "QuickBooks is not connected")], -1)), _cache[45] || (_cache[45] = _createElementVNode("p", null, " Some options are not available on this page until QuickBooks is connected. ", -1)), _createVNode(LlSecondaryButton, {
        color: "primary",
        onClick: _cache[28] || (_cache[28] = $event => goToCustomFieldsPage('settings.company.billing'))
      }, {
        default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode(" Learn More ", -1)]))]),
        _: 1
      })])], 512), [[_vShow, !_unref(invoiceState).connected]]), _withDirectives(_createElementVNode("div", null, [_cache[47] || (_cache[47] = _createElementVNode("p", null, " Much of the invoice presentation is controlled by settings in QuickBooks, specifically the \"Custom Form Style\" used for your invoices. Modify QuickBooks settings there: ", -1)), _createElementVNode("p", _hoisted_11, [_createVNode(LlSecondaryButton, {
        href: _unref(invoiceState).quickbooksLink,
        target: "_blank",
        rel: "noopener noreferrer"
      }, {
        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode(" QuickBooks Custom Form Styles ", -1)]))]),
        _: 1
      }, 8, ["href"])])], 512), [[_vShow, _unref(invoiceState).connected]]), _createVNode(InvoicePreviewTable, {
        invoiceState: _unref(invoiceState)
      }, null, 8, ["invoiceState"])])]), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: _unref(invoiceState).saving,
        unsaved: _unref(invoiceState).unsaved,
        onUpdate: _cache[29] || (_cache[29] = $event => saveSettings()),
        onCancel: _cache[30] || (_cache[30] = $event => cancel())
      }, null, 8, ["somethingChanged", "saving", "unsaved"])]))]);
    };
  }
};